import React, { useEffect, useLayoutEffect, useMemo, useState, useCallback, useRef, Suspense } from 'react';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { isEmpty } from 'lodash';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import {ReactComponent as Cross} from '@assets/images/cross.svg';
import cn from 'classnames';
import style from '@containers/MenuOrder/menuorder.module.scss';
import Styles from './index.module.scss';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable'
import Loader from '@components/common/Loader/newLoaderModal';
const Modal = React.lazy(() => import('@components/common/Modal'));
import { connect } from "react-redux";


const createTable = (props) => {

  // Props Destructuring
  const {
    type,
    maxLength,
    isAlpha,
    name,
    placeholder,
    onSubmit,
    isOpen,
    specialValue,
    buttonName,
    check,
    isPaymentApp,
    editSeatPopUP,
    isKeyboardHide,
    isEditSeatPopUp,
    BtnW100,
    serverAppTheme,
    cancelBtnName,
    onclose,
    header,
    orderingPortraitOrientation
  } = props;

  // State Management
  const [keyboardType, setKeyboardType] = useState('numericAlpha');
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [inputs, setInputs] = useState({
    [name]: specialValue
  });
  const [inputName, setInputName] = useState(name);
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [error, setError] = useState({});
  const [errMsg, setErrMsg] = useState();
  const [finatSeatArray, setFinalSeatArray] = useState();

  // Stable refs — read at call time so useCallback deps stay empty
  const inputNameRef = useRef(inputName);
  inputNameRef.current = inputName;
  // React Hooks
  useEffect(() => {
    let addedSeats = addSeatDynamically();
    isEditSeatPopUp && setFinalSeatArray(addedSeats)
    },[])


  useLayoutEffect(() => {
    if (isAlpha) {
      setKeyboardType('numericAlpha');
    } else {
      setKeyboardType(type === 'number' ? 'number' : type);
    }
  }, [type]);

  useLayoutEffect(() => {
    setInputs({
      ...inputs, [name]: specialValue
    });
  }, [isOpen]);

  const closeKeyboard = useCallback(() => {
    setSwipedDown(false);
  }, []);

  // Stable reference — reads inputName via ref, uses functional updater
  // for setInputs so it never needs to close over state.
  const onClickBtn = useCallback((e) => {
    setError({});
    setSelectedSeats([]);
    const currentInput = inputNameRef.current;
    setInputs(prev => {
      const prevVal = (prev && prev[currentInput]) || '';
      const newVal = e === '{bksp}' ? prevVal.slice(0, -1) : prevVal.concat(e);
      return { ...prev, [currentInput]: newVal };
    });
  }, []);

  const setEmpty = useCallback((data) => {
    setInputs(prev => ({ ...prev, [data]: '', error: '' }));
  }, []);
  const getInputValue = (inputNameDat) => {
    return (inputs[inputNameDat]) || '';
  };

  const buttonTheme = useMemo(() => ({
    '{done}': {
      class: 'bgGreen',
    }
  }), []);

  const submit = () => {
    editSeatPopUP && inputs[inputName] == ''  && setErrMsg(`Please enter stage ${name === 'stageName' ? 'name' : 'number'}`);
    onSubmit(selectedSeats.length > 0 ? selectedSeats : inputs[inputName]);
  };

  const validateSeatNumber = (val) => {
    if (selectedSeats.length > 0) {
      return submit();
    }
    const isSeat = JSON.parse(window.sessionStorage.getItem('seat')).seats.find((item) => (item.open && item.number === Number(val)));
    if (isEmpty(val)) {
      setError({ ...error, seatNumber: `Enter Seat ${name === 'seatName' ? 'Name' : 'Number'}` });
    } else if (isSeat) {
      setError({ ...error, seatNumber: 'Seat Number Already Taken' });
    }
    return val && !isSeat && submit();
  };

  const handleBlur = () => {
    setSwipedDown(true);
    const element = document.querySelector(`#${name}`);
    element.blur();
  };

  const addRemoveSeats = (node) => {
    setError({ ...error, seatNumber: '' });
    if (selectedSeats.indexOf(node) === -1 && selectedSeats.includes('table')) {
      setSelectedSeats([node]);
    } else if (selectedSeats.indexOf(node) === -1 && !selectedSeats.includes('table')) {
      setSelectedSeats(selectedSeats.concat(node));
    } else {
      setSelectedSeats(selectedSeats.filter((x) => x !== node));
    }
    if (node === 'table') {
      setSelectedSeats(['table']);
    }
  };

  let seatArrays = [];
  const addSeatDynamically = () => {
    if (isEditSeatPopUp) {
      let count = 0;
      let seatCount = 1;
        while(count < 24) {
          if(check?.seats?.filter((e) => e.open && e.number === seatCount).length === 0) {
            seatArrays[count] = seatCount;
            count++;
            seatCount++;
        } else {
            seatCount++;
        }
        }
        return seatArrays
    }
  }

  const keyboardStyle = useMemo(() => {
    const styling = {
      background: serverAppTheme?.inputBg,
      borderBottom: serverAppTheme?.inputBorder_Bottom,
      color: serverAppTheme?.primary_text,
      '--placeholder-color': serverAppTheme?.input_placeholder,
      height: orderingPortraitOrientation ? '4rem' : '2.75rem'
    }

    return {styling}
  }, [serverAppTheme])

  // HTML CSS CODE

  const handleRenameClick = () => {
        if(!inputs[inputName]){
          props.setErrorPopUp({
                    res: CUSTOM_MESSAGES().RENAME_SEAT_ERROR,
                    noErrorTxt: true,
                    onClickChange: () => {},
                });
        } else {
          name === 'seatNumber' ? validateSeatNumber(getInputValue(name)) : submit()
        }
  }

  return (
    <>
    <div className={cn('col-12 large-input justify-content-center position-relative', orderingPortraitOrientation ? 'px-3 h-96' : 'px-0 h-90'  )} style={{marginLeft: 'auto',marginRight:'auto'}}>
      {header && <div className={cn('col-12 px-0 pt-3 pb-2', orderingPortraitOrientation ? 'fs_24 fw-400 position-relative' : 'fs_18 fw-700')} style={{color: serverAppTheme?.primary_text, top: orderingPortraitOrientation ? '20%' : ''}}>{header}</div>}
      {!isKeyboardHide && <div className={cn('col-12 p-0 position-relative', orderingPortraitOrientation ? (header ? Styles.headerInput : Styles.inputPortrait) : (header ? Styles.inputLandscape : Styles.inputWithoutHeader))}>
      <div className={cn('col-12 p-0 mb-0 position-relative')}>
        <input
          id={name}
          type="text"
          name={name}
          className={cn("fs_26 fw-400 border-left-0 border-right-0 border-top-0 rounded-0 text-left", orderingPortraitOrientation ? 'col-12' : 'col-10', style.input)}
          style={keyboardStyle.styling}
          placeholder={placeholder}
          value={getInputValue(name)}
          onFocus={() => { handleBlur(); setInputName(name); setKeyboardType(type); }}
        />
         {(inputs[name]?.length > 0) && (
          <TouchableDiv
            role="presentation"
            className={cn("position-absolute h-100 d-flex justify-content-center align-items-center")}
            style={{top: '0', right: "76px"}}
            onClick={() => { setInputName(name); setEmpty(name); }}
          >
           <Cross fill={serverAppTheme?.iconcolor} aria-hidden="true" />
          </TouchableDiv>
          )}
      </div>
      {errMsg && !isKeyboardHide && <div className='error fs-12 d-flex justify-content-end'>{errMsg}</div>}
      </div>
      }
      {check && (
        <div className={cn('row mx-0 flex-wrap overflowY w-100', Styles.gridWrapperCopy)}>
          {finatSeatArray?.map((item) => {
            return (
              <>
                {check.seats.filter((e) => e.open && item === Number(e.number)).length === 0 && (
                  <div key={item} role="presentation" onClick={() => { addRemoveSeats(item); setEmpty(name); }} className={cn(isPaymentApp? style.btnBorderWhiteCopyPay : style.btnBorderWhiteCopy, selectedSeats.length > 0 && selectedSeats.includes(item) ? `btn-ripple  ${style.selectedSeats}` : ` ${style.unSelectedSeats}`, 'd-flex justify-content-center align-items-center border rounded mr-1 mb-1 fs_32 fw-500')}
                  style={{ color: selectedSeats?.includes(item) ? '#000' : serverAppTheme?.primary_text,  border:selectedSeats?.includes(item) ? 'none' : serverAppTheme?.popupBorder, background:selectedSeats?.includes(item) ? serverAppTheme?.selected : serverAppTheme?.unselected}}
                  >{item}</div>
                )}
              </>
            );
          })}
        </div>
      )}
      {error?.seatNumber?.length > 0 && (
        <div className="error fs-12 d-block">
          {error.seatNumber}
        </div>
      )}
      <div
        className={cn('col-12 px-0 d-flex justify-content-center position-absolute', orderingPortraitOrientation ? 'pr-3' : '')}
        style={{
          bottom: orderingPortraitOrientation ? '16px' : "-10px"
        }}
      >
        {cancelBtnName &&
        <div className={cn('pl-0', orderingPortraitOrientation ? 'col-6' :'col-4')}>
          <TouchableButton
            className={cn('px-0 fs_28 fw-600 rounded mr-2 w-100')}
            type="button"
            onClick={(e) => {onclose(); e.preventDefault();}}
            style={{ height: BtnW100 ? '7.5vh' : '8.5vh', backgroundColor: serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.cancleBtn_font, border: serverAppTheme?.cancleBtn_Border }}
            rippleEffect={true}
          >
            {cancelBtnName}
          </TouchableButton>
          </div>
        }
         <div className={cn('pl-0', orderingPortraitOrientation ? 'col-6' :'col-4')}>
          <TouchableButton
          className={cn('px-0 fs_28 fw-600 w-100', Styles.primary_btn)}
          type="button"
          onClick={(e) => {handleRenameClick(); e.preventDefault();}}
          style={{ height: BtnW100 ? '7.5vh' : '8.5vh', backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}

          rippleEffect={true}
        >
          {buttonName}
        </TouchableButton>
        </div>

      </div>
      {isSwipedDown && (
        <>
          {!isKeyboardHide && (
            <div
              className={cn(
                keyboardType === 'numericWithdone' || keyboardType === 'numericAlpha'
                  ? (isPaymentApp
                    ? Styles.keyboardCopyPaymentApp
                    : Styles.keyboardCopy)
                  : orderingPortraitOrientation ? Styles.keyboardPortrait : Styles.keyboard1
              )}
              style={{ border: isPaymentApp ? '5px solid black' : '', width: isPaymentApp ? '92%' : '' }}>
              {!isKeyboardHide &&
                <CustomKeyboard
                  setKeyboardType={setKeyboardType}
                  onClickBtn={onClickBtn}
                  type={keyboardType}
                  closeKeyboard={closeKeyboard}
                  btnSize={keyboardType === 'textWithoutNumeric' ? 'btn35' : "btn35"}
                  customClass={"fs-30 p-2"}
                  maxLength={maxLength}
                  buttonTheme={buttonTheme}
                  setinputEmpty={setEmpty}
                  isOrderSeat={true}
                />
              }
              {isPaymentApp && !isKeyboardHide && <div className="d-flex">
                <button type="button" className="w-100 px-0 m-1 h-100 btn-ripple btn100 text-white od-btn-secondary roundedSm"
                  onClick={() => closeKeyboard()}
                >
                  <div className={cn('fs_28 fw-600 text-uppercase', style.cancelButtonStyling)}>{LABEL().CANCEL}</div>
                </button>
                <button
                  type="button"
                  className={cn("w-100 px-0 m-1 h-100 pb-1 btn-ripple btn100 od-btn-primary text-white", style.submitButtonStyling)}
                  onClick={() => submit()}
                >
                  <div className={cn('fs_28 fw-600 text-uppercase')}>{LABEL().CONTINUE}</div>
                </button>
              </div>}
            </div>
          )}
        </>
      )}
    </div>
          <Suspense fallback={<Loader />}>
            </Suspense>
    </>
  );
};
const mapStateToProps = ({ orders }) => ({
  orderingPortraitOrientation: orders.orderingPortraitOrientation
});

export default connect(mapStateToProps)(createTable);
